export default "__VITE_ASSET__fa6739f4__"